<div class="flex" [formGroup]="parentForm">
    <p>{{name}}</p>
    <label class="switch">
        <input type="checkbox" (click)="switchState()">
        <span class="slider round"></span>
    </label>
    <p>{{onOff ? 'On': 'Off'}}</p>
</div>